enum NotificationActionType {
  HideNotification = 'notifications/hideNotification',
  ShowNotification = 'notifications/showNotification',
}

export default NotificationActionType;
